import { render, staticRenderFns } from "./PacientesExistentes.vue?vue&type=template&id=4e0621d4&scoped=true&"
import script from "./PacientesExistentes.vue?vue&type=script&lang=js&"
export * from "./PacientesExistentes.vue?vue&type=script&lang=js&"
import style0 from "./PacientesExistentes.vue?vue&type=style&index=0&id=4e0621d4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e0621d4",
  null
  
)

export default component.exports